import React from 'react';
import {AutocompleteDictionary} from './autocomplete';
import * as _find from 'lodash/find';

// Presentation
function ControlSpecialty(props) {
    const getDictionaryURL = filter => {
        let newFilter = 'relevent eq true';
        if (filter !== '') {
            newFilter = 'relevent eq true and ' + filter;
        }
        return `/$dict/Specialties?$filter=${encodeURIComponent(newFilter)}&$sort=description`;
    };

    const renderOptionLine = (createParts, option, classes, props) => {
        return (
            <div {...props} key={'specialty_option_' + option.__id}>{option.__description}</div>
        );
    };

    return (
        <AutocompleteDictionary
            showAll
            getOptionSelected={(option, value) => option.__id === value.__id}
            getOptionLabel={(option) => option?.__description || ''}
            renderLocalOption={renderOptionLine}
            searchColumnName={'description'}
            filterByIds={props.filterByIds}
            filterIds={props.filterIds}
            dictionaryURL={getDictionaryURL}
            getOptionDisabled={(option) => {
                if (props.alreadySelected) {
                    return _find(props.alreadySelected, function (aso) {
                        return aso.__id === option.__id;
                    }) != null;
                } else {
                    return false;
                }
            }}
            {...props}
        />
    );
}

export default ControlSpecialty;
